import { Link, Text, types } from "react-bricks/frontend"
import ImageEditor, { AspectRatio } from "../../../../react-bricks/Image"
import React from "react"

interface AboTeaserItemProps {
    href: string
}

const AboTeaserItem: types.Brick<AboTeaserItemProps> = ({ href }) => {
    return (
        <Link href={href}>
            <ImageEditor aspectRatio={AspectRatio["1/1"]} className="mb-3.5 rounded-base sm:mb-7 lg:mb-5 xl:mb-7" />
            <Text
                propName="text"
                placeholder="Lorem ipsum"
                renderBlock={({ children }) => (
                    <span className="text-base font-semibold sm:text-xl lg:text-lg xl:text-xl">
                        {children}
                        <span className="whitespace-nowrap">
                            <i className="lavita-icon -mt-0.5 ml-2 inline-block shrink-0 align-middle text-sm leading-none sm:text-md lg:text-base xl:text-md">
                                
                            </i>
                        </span>
                    </span>
                )}
            />
        </Link>
    )
}

AboTeaserItem.schema = {
    name: "AboTeaserItem",
    label: "Abo Teaser Item",
    hideFromAddMenu: true,
    sideEditProps: [
        {
            name: "href",
            label: "Link",
            type: types.SideEditPropType.Text,
        },
    ],
}

export default AboTeaserItem
